<template>
  <v-dialog
    v-model="visible"
    max-width="750"
    persistent
    overlay-opacity="0.6"
  >
    <v-card v-if="currentPopup" class="popup-overlay-card">
      <v-img
        v-if="currentPopup.image_url"
        :src="currentPopup.image_url"
        max-height="320"
        contain
        class="grey lighten-3"
      />

      <v-card-title class="text-h6 font-weight-bold pt-4 pb-1">
        {{ currentPopup.title }}
      </v-card-title>

      <v-card-text v-if="currentPopup.message" class="text-body-2 pb-2" style="white-space: pre-line;">
        {{ currentPopup.message }}
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <span v-if="popups.length > 1" class="text-caption grey--text ml-2">
          {{ currentIndex + 1 }} de {{ popups.length }}
        </span>
        <v-spacer />
        <v-btn
          color="primary"
          @click="dismiss"
        >
          {{ isLast ? 'Fechar' : 'Próximo' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SysTeacherPopupOverlay',
  props: {
    popups: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    currentIndex: 0,
  }),
  computed: {
    visible: {
      get() { return this.show && this.popups.length > 0 },
      set(val) {
        if (!val) this.$emit('update:show', false)
      },
    },
    currentPopup() {
      return this.popups[this.currentIndex] || null
    },
    isLast() {
      return this.currentIndex >= this.popups.length - 1
    },
  },
  watch: {
    show(val) {
      if (val) this.currentIndex = 0
    },
  },
  methods: {
    dismiss() {
      if (this.currentPopup) {
        this.$emit('read', this.currentPopup.id)
      }

      if (this.isLast) {
        this.visible = false
        this.$emit('dismissed')
      } else {
        this.currentIndex++
      }
    },
  },
}
</script>

<style scoped>
.popup-overlay-card {
  border-radius: 12px;
  overflow: hidden;
}
</style>
